import styles from "./CreateModal.module.css";

function CreateModal({ isOpen, onCreate, onClose }) {
    if (!isOpen) return null;

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const plan = {
            name: formData.get("name"),
            version: formData.get("version"),
            price: formData.get("price"),
            cycle: formData.get("ciclo"),
            image: formData.get("imagem"),
            description: formData.get("description"),
            points: formData.get("pontos"),
        };
        onCreate(plan);
        onClose();
    }

    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>
                <h2>Criar Novo Plano</h2>
                <form onSubmit={handleSubmit}>
                    <input name="name" placeholder="Nome do plano" required />
                    <input name="price" placeholder="Preço (€)" type="number" step="0.01" required />
                    <select name="ciclo" placeholder="Ciclo de Pagamento">
                        <option value="mensal">Mensal</option>
                        <option value="semanal">Semanal</option>
                    </select>
                    <input name="imagem" placeholder="Imagem" required />
                    <input name="description" placeholder="Resumo" required />
                    <textarea name="pontos" placeholder="Descrição" required />
                    <div className={styles.buttons}>
                        <button className={styles.cancelButton} type="button" onClick={onClose}>Cancelar</button>
                        <button className={styles.confirmButton} type="submit">Criar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateModal;
